import autosize from 'autosize';
import FormField from '../utils/form-field';

(function() {
	document.addEventListener('DOMContentLoaded', () => {
		const eyeLayout = (opened = false) => `
    ${
			opened
				? `
        <svg class="form-field__pass-opened-eye" width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="form-field__pass-eye_body" d="M12 1.4375C5.55 1.4375 0.9375 8 0.9375 8C0.9375 8 5.55 14.5625 12 14.5625C18.45 14.5625 23.0625 8 23.0625 8C23.0625 8 18.45 1.4375 12 1.4375Z" stroke="#FCFCFC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="form-field__pass-eye_circle" d="M12 11.5625C14.0711 11.5625 15.75 9.88357 15.75 7.8125C15.75 5.74143 14.0711 4.0625 12 4.0625C9.92893 4.0625 8.25 5.74143 8.25 7.8125C8.25 9.88357 9.92893 11.5625 12 11.5625Z" fill="#FCFCFC"/>
        </svg>
      `
				: `
        <svg class="form-field__pass-closed-eye" width="27" height="13" viewBox="0 0 27 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 1C2 1 6.6125 7.5625 13.0625 7.5625C19.5125 7.5625 24.125 1 24.125 1" stroke="#FCFCFC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.99128 4.76115C4.80783 5.20691 3.5 7.5 2.00007 6.49996" stroke="#FCFCFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.0837 8.00001C10.1511 8.4773 10.184 11.1169 8.38417 11.0137" stroke="#FCFCFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 8.26945C16.0617 8.74751 16.7309 11.3011 18.4387 10.7238" stroke="#FCFCFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.9367 4.10483C22.1898 4.51508 23.851 6.56669 25.1696 5.3374" stroke="#FCFCFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
		}
    `;
		const checkIcon = `
    <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 4L5 8L12 1" stroke="#58D94D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

		const inputs = document.getElementsByClassName('form-field');

		for (const inputWrap of inputs) {
			const input = inputWrap.getElementsByClassName('form-field__input')[0];
			const fieldWrap = inputWrap.getElementsByClassName('form-field__wrap')[0];

			FormField.toggleFilledModifier(input);

			// Placeholder location onchange input value
			input.addEventListener('change', () => FormField.toggleFilledModifier(input));

			// Placeholder location onfocus input
			input.addEventListener('focus', () => FormField.toggleFilledModifier(input));

			// Creating placeholder
			const inputPlaceholder = document.createElement('div');
			inputPlaceholder.className = 'form-field__placeholder';
			if (input.tagName === 'DIV') inputPlaceholder.innerHTML = input.getAttribute('data-placeholder');
			else inputPlaceholder.innerHTML = input.placeholder;
			fieldWrap.appendChild(inputPlaceholder);

			// Focus on input when placeholder is clicked
			inputPlaceholder.addEventListener('click', () => input.focus());

			// Eye button for input type password
			if (input.type === 'password') {
				const eye = document.createElement('div');
				input.classList.add('--pass');
				eye.className = 'form-field__eye';
				eye.innerHTML = eyeLayout(true);
				fieldWrap.appendChild(eye);

				// Show password / hide password
				eye.addEventListener('click', () => {
					if (input.type === 'password') {
						input.type = 'text';
						eye.innerHTML = eyeLayout(false);
					} else {
						input.type = 'password';
						eye.innerHTML = eyeLayout(true);
					}
				});
			}

			// Creating check icon
			const checkIconNode = document.createElement('div');
			checkIconNode.className = 'form-field__check-ic';
			checkIconNode.innerHTML = checkIcon;
			fieldWrap.appendChild(checkIconNode);

			// Textarea
			if (input.tagName === 'TEXTAREA' && input.classList.contains('--autosize')) {
				autosize(input);
			}
		}
	});
})();
